import { ClickFormsAdjustmentGridFieldsMap } from '../../types.js';

export const FNMA2055_TOTAL_ROWS = 546;
export const FNMA2055_SALES_COMP_GRID_ROWS_PER_COMP = 60;

export const FNMA2055_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 262,
  saleFinanceAdj: 267,
  concAdj: 269,
  dateOfSaleAdj: 271,
  locationAdj: 273,
  propRightsAdj: 275,
  siteAdj: 277,
  viewAdj: 279,
  designAdj: 281,
  qualityAdj: 283,
  actualAgeAdj: 285,
  conditionAdj: 287,
  aboveGradeAdj: 388,
  roomCountAdj: 292,
  glaAdj: 294,
  basementLine1Adj: 296,
  basementLine2Adj: 298,
  funcUtilAdj: 300,
  heatingCoolingAdj: 302,
  energyEffAdj: 304,
  garageCarportAdj: 306,
  porchPatioAdj: 308,
  blank1Adj: 310,
  blank2Adj: 312,
  blank3Adj: 314,
};

export const FNMA2055_ROWS = {
  SU_BLANK1_LABEL: 253,
  SU_BLANK2_LABEL: 255,

  // COMP 1
  C1_NET_ADJ_POS_CHECKBOX: 315,
  C1_NET_ADJ_NEG_CHECKBOX: 316,
  C1_NET_ADJ_TOTAL: 317,
  C1_ADJ_SALE_PRICE: 318,

  // COST APPROACH
  CA_SUPPORT_FOR_SITE_VALUE: 485,
  CA_REPRODUCTION_CHECKBOX: 486,
  CA_REPLACEMENT_COST_NEW_CHECKBOX: 487,
  CA_COST_DATA_SOURCE: 488,
  CA_QUALITY: 489,
  CA_EFFECTIVE_DATE: 490,
  CA_COMMENTS: 491,
  CA_ESTIMATED_REMAINING_ECON_LIFE: 492,
  CA_OPINION_OF_SITE_VALUE: 493,
  CA_DWELLING_SQFT: 494,
  CA_DWELLING_COST_PER_SQFT: 495,
  CA_DWELLING_COST: 496,
  CA_OTHER1_LABEL: 497,
  CA_OTHER1_SQFT: 498,
  CA_OTHER1_COST_PER_SQFT: 499,
  CA_OTHER1_COST: 500,
  CA_OTHER2: 501,
  CA_OTHER2_COST: 502,
  CA_GARAGE_CARPORT_SQFT: 503,
  CA_GARAGE_CARPORT_COST_PER_SQFT: 504,
  CA_GARAGE_CARPORT_COST: 505,
  CA_TOTAL_ESTIMATE_OF_COST_NEW: 506,
  CA_DEPR_PHYS: 508,
  CA_DEPR_FUNC: 510,
  CA_DEPR_EXTN: 512,
  CA_DEPR_TOTAL: 513,
  CA_DEPR_COST_OF_IMPROVEMENTS: 514,
  CA_AS_IS_SITE_IMPROVEMENTS: 515,
  CA_INDICATED_VALUE: 516,
  CA_EFFECTIVE_AGE: 147,
};
